<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :disabled="disabled"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <div :data-dusk="dataDusk">
            <a-select
                :id="selectIdentifier"
                :dropdownClassName="'dd-option-' + selectIdentifier"
                :show-search="searchable"
                :default-value="defaultValue"
                :value="parsedValue"
                :options="parsedOptions"
                :filter-option="filterOption"
                :disabled="disabled"
                :name="name"
                v-bind="$attrs"
                :style="{width: 100 + '%' }"
                @deselect="(newValue) => $emit('deselect', newValue)"
                @select="(newValue) => $emit('select', newValue)"
                @change="(newValue) => {validateInput(newValue); onChange(newValue)}"
                @focus="(val) => $emit('focus', val)"
                @search="(val) => $emit('search', val)"
                @blur="(val) => {validateInput(val); $emit('blur', val)}"
            >
             <slot></slot>
            </a-select>
          </div>
        </dd-input-wrapper>
      </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FormSelect',
  emits: ['input', 'select', 'deselect', 'search', 'blur'],
  props: {
    dataDusk: {
      value: String,
      required: false
    },
    title: {
      value: String,
      required: false
    },
    name: {
      value: String,
      required: false
    },
    value: {
      value: [String, Array, Number],
      required: false
    },
    defaultValue: {
      value: [String, Array, Number],
      required: false
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    options: {
      type: Array,
      required: false
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    filterOption: {
      type: Function,
      required: false,
      default: (input, option) => {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }
    }
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    selectIdentifier:() => _.uniqueId(),
    parsedValue() {
      // If no valid value is given set to undefined.
      if (this.value === null || this.value === '' || this.value === undefined) return undefined;

      // Non empty values can be stringified.
      if (Array.isArray(this.value)) {
        return this.value.map((value) => {
          // If no valid value is given set to undefined.
          if (value === null || value === '' || value === undefined) return undefined
          return value.toString();
        });
      }

      return this.value.toString();
    },
    parsedOptions() {
      if (!this.options) return;
      return this.options.map((option) => ({
        label: option.label,
        value: option.value.toString(),
      }));
    },
  },
  methods: {
    onChange(input) {
      // Emit string as numeric value if it is a numeric value, else as string.
      // Multiple
      const isNumerical = (input) => String(input).search(/^[0-9]+$/) > 0;
      if (Array.isArray(input)) {
        this.$emit('input', input.map((item) => {
          if (isNumerical(item)) {
            return parseInt(item);
          } else {
            return item;
          }
        }));
      } else if (isNumerical(input)) {
        this.$emit('input', parseInt(input));
      } else {
        this.$emit('input', input);
      }
    },
  },
}
</script>
